import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { EMPTY, map, Observable } from "rxjs";

import { convertToExternalUrl, getInternalUrl } from "#shared/utils/link-helpers";

import { ExternalNavigationComponent } from "#modules/home/components/external-navigation/external-navigation.component";
import { NodeContentTypes, parseAnchorLink } from "#modules/shared/services/content-check.service";

@Injectable({ providedIn: "root" })
export class LinkInterceptor {
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  maybeRedirect(value: HTMLAnchorElement | NodeContentTypes.Link, beforeRedirect?: () => void): Observable<void> {
    // not in the editor
    if (location.pathname.includes("/editor/")) return EMPTY;

    const link = value instanceof HTMLAnchorElement ? parseAnchorLink(value) : value;

    if (!link) return EMPTY;

    const { href, name, target } = link;

    const internalUrl = getInternalUrl(href);
    // If we have a download link then bail
    if (internalUrl?.toLowerCase().startsWith("/pdf")) return EMPTY;

    if (internalUrl) {
      // If we have an internal link openining in a new tab then bail
      if (!href.length || target.toLowerCase() === "_blank") return EMPTY;

      beforeRedirect?.();
      this.router.navigateByUrl(internalUrl);
      return EMPTY;
    } else {
      beforeRedirect?.();
      return this.dialog
        .open(ExternalNavigationComponent, {
          data: { url: convertToExternalUrl(href), name },
        })
        .afterClosed()
        .pipe(map(() => {}));
    }
  }
}
